import { useNavigate } from "react-router-dom";
import React, { useEffect, useState, useCallback } from "react";
// import { useAuth } from "../../app/useAuth";
import MainLayout from "../../components/layouts/main";

export default function N6Records() {
    // const auth = useAuth();
    const navigate = useNavigate();
    const [textSearch, setTextSearch] = useState("");
    const [submitSearch, setSubmitSearch] = useState(false);
    const [advancedSearchText, setAdvancedSearchText] = useState("");

    const handleSubmitSearch = useCallback(() => {
        navigate(`/search/n6/${textSearch}`);
        setSubmitSearch(false);
    }, [textSearch, navigate]);

    useEffect(() => {
        if (submitSearch) {
            handleSubmitSearch();
        }
    }, [submitSearch, handleSubmitSearch]);

    return (
        <MainLayout
            pathname="/search/n6"
            header="Primer Validation"
            exampleText={
                <div>
                    Examples - Primer: <span className="text-primary">RM3691</span>,<span className="text-primary"> RM4355</span>,{" "}
                    <span className="text-primary">RM10022</span>
                </div>
            }
            textSearch={textSearch}
            setTextSearch={setTextSearch}
            setSubmitSearch={setSubmitSearch}
            setAdvancedSearchText={setAdvancedSearchText}
        />
    );
}
